import { Component, Input, OnChanges, OnInit, inject, viewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LuckyDrawStrategy, ProductReward, ReceiptCheckOptions, ReceiptManualValidationRule } from 'src/app/api/api-campaigns.service.generated';
import { ConsumptionFiltersEditComponent } from '../../_/consumption-filters-edit/consumption-filters-edit.component';
import { RewardSelectComponent } from '../../_/reward-select/reward-select.component';
import { RewardChancesSelectComponent } from '../reward-chances-select/reward-chances-select.component';
import { RewardsProductApiClient, ProductInfo } from 'src/app/api/api-rewards.service.generated';
import { ReceiptCheckOptionsEditComponent } from '../../_/receipt-check-options-edit/receipt-check-options-edit.component';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-lucky-draw-strategy',
  templateUrl: './lucky-draw-strategy.component.html',
  styleUrls: ['./lucky-draw-strategy.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    FlexLayoutModule,
    ConsumptionFiltersEditComponent,
    RewardSelectComponent,
    RewardChancesSelectComponent,
    ReceiptCheckOptionsEditComponent
]
})
export class LuckyDrawStrategyComponent implements OnInit, OnChanges {
  private rewardProductsApi = inject(RewardsProductApiClient);


  @Input() strategy: LuckyDrawStrategy;
  @Input() advertiserId: string;

  readonly filters = viewChild<ConsumptionFiltersEditComponent>('filters');
  readonly rewardChances = viewChild<RewardChancesSelectComponent>('rewardChances');
  readonly joinReward = viewChild<RewardSelectComponent>('joinReward');
  readonly firstConsumptionReward = viewChild<RewardSelectComponent>('firstConsumptionReward');
  readonly consumptionReward = viewChild<RewardSelectComponent>('consumptionReward');


  form = new FormGroup({
    // lucky draw
    scorePerChance: new FormControl(null, [Validators.required, Validators.min(0), Validators.max(100)]),
    maxChancesPerConsumptionEvent: new FormControl(null, [Validators.required, Validators.min(0), Validators.max(100)]),
    initialChanceCount: new FormControl(null, [Validators.required, Validators.min(0), Validators.max(100)]),
    secondsBetweenChances: new FormControl(null),
    gameSlug: new FormControl(''),
    receiptCheck: new FormControl()
  });

  gameRewardProductsOptions: ProductReward[] = [];

  ngOnChanges(): void {
    if (!this.strategy) return;
    setTimeout(() => {
      this.setFormValue(this.strategy);
    }, 500);
  }

  async ngOnInit() {
    const gameProductInfos = await lastValueFrom(this.rewardProductsApi.getProductsByCategorySlug('game_rewards'));
    this.gameRewardProductsOptions = gameProductInfos.map((pi: ProductInfo) =>
      new ProductReward({
        productSlug: pi.slug,
        rewardTitle: pi.name,
        rewardDescription: pi.description,
        rewardThumbUrl: pi.photoUrl,
        rewardPhotoUrl: pi.photoUrl
      }));
  }


  setFormValue(model: LuckyDrawStrategy) {
    this.filters().setFormValue(model.consumptionFilters);

    this.rewardChances().setFormValue(model.rewardChances);

    this.joinReward().setFormValue(model.joinReward);
    this.firstConsumptionReward().setFormValue(model.firstConsumptionReward);
    this.consumptionReward()?.setFormValue(model.consumptionReward);

    this.form.patchValue({
      scorePerChance: model.scorePerChance,
      maxChancesPerConsumptionEvent: model.maxChancesPerConsumptionEvent,
      initialChanceCount: model.initialChanceCount,
      secondsBetweenChances: model.secondsBetweenChances,
      // gameUrl: model.gameUrl,
      gameSlug: model.gameSlug,
      receiptCheck: model.receiptCheck ? new ReceiptCheckOptions({ ...model.receiptCheck }) : undefined,
    });
  }

  getFormValue() {
    const f = this.form.value;

    const model = new LuckyDrawStrategy({
      ...this.strategy,
      name: 'LuckyDrawObsolete',

      scorePerChance: +f.scorePerChance,
      maxChancesPerConsumptionEvent: +f.maxChancesPerConsumptionEvent,
      initialChanceCount: +f.initialChanceCount,
      secondsBetweenChances: +f.secondsBetweenChances,
      // gameUrl: f.gameUrl,
      gameSlug: f.gameSlug,

      consumptionFilters: this.filters().getFormValue(),
      rewardChances: this.rewardChances().getFormValue(),

      joinReward: this.joinReward().getFormValue(),
      firstConsumptionReward: this.firstConsumptionReward().getFormValue(),
      consumptionReward: this.consumptionReward().getFormValue(),
      receiptCheck: f.receiptCheck,

      receiptManualValidationRule: this.strategy?.receiptManualValidationRule
        ? ReceiptManualValidationRule.fromJS(this.strategy.receiptManualValidationRule)
        : undefined
    });
    return model;
  }

  isValid() {
    const isValid = this.form.valid &&
      this.filters().isValid() &&
      this.rewardChances().isValid();
    if (!isValid)
      this.forceValidatorsToDisplayErrors();

    return isValid;
  }



  async onSubmit() {
  }



  compareFn: ((a: any, b: any) => boolean) | null = (a: any, b: any) => a && b && a.id === b.id;


  forceValidatorsToDisplayErrors() {
    // force validators to display errors
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key).markAsTouched();
      this.form.get(key).markAsDirty();
    });

    this.filters().forceValidatorsToDisplayErrors();
    this.rewardChances().forceValidatorsToDisplayErrors();
  }

}


// To validate password and confirm password
export function rewardRequired(f1: string, f2: string) {
  return (form: FormGroup) => {
    const c1 = form.controls[f1];
    const c2 = form.controls[f2];

    if (!c1.value && !c2.value)
      c1.setErrors({ rewardRequired: true });
    else
      c1.setErrors(null);
  };
}



